import React, { useState } from 'react';

const SubmitDataForm = ({ setModalMessage }) => {
  // --- STATE AND DATA MANAGEMENT (No Changes) ---
  const [formData, setFormData] = useState({
    street: '',
    city: '',
    state: '',
    zip: '',
    stars: 0,
    rent: '',
    review_text: '',
    maintenance_rating: 0,
    electricity_bill: '',
    water_bill: '',
    gas_bill: '',
    unified_bill: '',
    num_bedrooms: '',
    num_bathrooms: '',
    num_closets: '',
    laundry_type: '',
    property_type: '',
    trash_type: '',
    apt_no: '',
    is_rent_total: 0,
    number_of_roommates: 0,
    furniture: 0,
    parking: 0,
    parking_fees: 0,
    sign_on_fees: 0,
  });

  const [billEntryMode, setBillEntryMode] = useState('individual');
  const [selectedBills, setSelectedBills] = useState([]);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const userId = localStorage.getItem('user_id');

  const ParkingFeeInput = ({ value, onChange }) => (
    <div className="form-group">
      <label className="form-label" htmlFor="parking_fees">Parking Fee Per Month</label>
      <input
        id="parking_fees"
        type="number"
        className="form-input"
        value={value || ''}
        onChange={(e) => onChange('parking_fees', e.target.value)}
        required
      />
    </div>
  );

  const laundryOptions = [
    { id: 1, label: 'In Unit' },
    { id: 2, label: 'On Site' },
    { id: 3, label: 'None' },
  ];
  const propertyTypeOptions = [
    { id: 1, label: 'Apartment' },
    { id: 2, label: 'House' },
    { id: 3, label: 'Condo' },
    { id: 4, label: 'Townhouse' },
  ];
  const trashTypeOptions = [
    { id: 1, label: 'Included' },
    { id: 2, label: 'Separate Bill' },
    { id: 3, label: 'Not Provided' },
  ];

  const rentTypeOptions = [
    {id: 1, label: 'My share of the rent'},
    {id: 2, label: 'Total property rent'},
  ];

  const furnitureOptions = [
    {id: 1, label: 'Fully Furnished'},
    {id: 2, label: 'Semi-Furnished'},
    {id: 3, label: 'Not Furnished'}
  ];

  const parkingOptions = [
    {id: 1, label: 'Included'},
    {id: 2, label: 'Paid'},
    {id: 3, label: 'Street'},
    {id: 4, label: 'None'}
  ]

   const stateOptions = [
    'AL', 'AK', 'AZ', 'AR', 'CA', 'CO', 'CT', 'DE', 'FL', 'GA',
    'HI', 'ID', 'IL', 'IN', 'IA', 'KS', 'KY', 'LA', 'ME', 'MD',
    'MA', 'MI', 'MN', 'MS', 'MO', 'MT', 'NE', 'NV', 'NH', 'NJ',
    'NM', 'NY', 'NC', 'ND', 'OH', 'OK', 'OR', 'PA', 'RI', 'SC',
    'SD', 'TN', 'TX', 'UT', 'VT', 'VA', 'WA', 'WV', 'WI', 'WY'
  ];

  // --- HANDLERS AND SUBMISSION LOGIC (No Changes) ---
  const handleInputChange = (field, value) => {
    const numericFields = [
      'stars',
      'rent',
      'maintenance_rating',
      'electricity_bill',
      'water_bill',
      'gas_bill',
      'unified_bill',
      'num_bedrooms',
      'num_bathrooms',
      'num_closets',
      'laundry_type',
      'property_type',
      'trash_type',
      'apt_no',
      'is_rent_total',
      'number_of_roommates',
      'furniture',
      'parking',
      'parking_fees',
      'sign_on_fees'
    ];
    setFormData((prev) => ({
      ...prev,
      [field]: numericFields.includes(field)
        ? value === ''
          ? ''
          : Number(value)
        : value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!userId) {
      setModalMessage('User ID missing. Please log in.');
      return;
    }

    setIsSubmitting(true);
    const token = localStorage.getItem('token');
    if (!token) {
      setModalMessage('Authentication token missing. Please log in.');
      setIsSubmitting(false);
      return;
    }

    try {
      const payload = {
        user_id: Number(userId),
        street: formData.street || null,
        city: formData.city || null,
        state: formData.state || null,
        zip: formData.zip || null,
        stars: formData.stars || null,
        rent: formData.rent === '' ? null : Number(formData.rent),
        review_text: formData.review_text || null,
        maintenance_rating: formData.maintenance_rating || null,
        num_bedrooms:
          formData.num_bedrooms === '' ? null : Number(formData.num_bedrooms),
        num_bathrooms:
          formData.num_bathrooms === '' ? null : Number(formData.num_bathrooms),
        num_closets:
          formData.num_closets === '' ? null : Number(formData.num_closets),
        laundry_type: formData.laundry_type || null,
        type: formData.property_type || null,
        trash_type: formData.trash_type || null,
        apt_no: formData.apt_no || null,
        is_rent_total: formData.is_rent_total || null,
        number_of_roommates: formData.number_of_roommates || null,
        furniture: formData.furniture || null,
        parking: formData.parking || null,
        parking_fees: formData.parking_fees || null,
        sign_on_fees: formData.sign_on_fees || null
      };

      if (billEntryMode === 'unified' && formData.unified_bill !== '') {
        payload.utility_bill = Number(formData.unified_bill);
      } else {
        if (formData.electricity_bill !== '')
          payload.electricity_bill = Number(formData.electricity_bill);
        if (formData.water_bill !== '')
          payload.water_bill = Number(formData.water_bill);
        if (formData.gas_bill !== '')
          payload.gas_bill = Number(formData.gas_bill);
      }

      Object.keys(payload).forEach((k) => {
        if (payload[k] === null) delete payload[k];
      });

      const response = await fetch(
        process.env.REACT_APP_BACKEND_URL + '/api/review/new-review',
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify(payload),
        }
      );

      if (!response.ok) throw new Error('Failed to submit data.');
      setModalMessage('Thank you for your submission!');
      setFormData({
        street: '',
        city: '',
        state: '',
        zip: '',
        stars: 0,
        rent: '',
        review_text: '',
        maintenance_rating: 0,
        electricity_bill: '',
        water_bill: '',
        gas_bill: '',
        unified_bill: '',
        num_bedrooms: '',
        num_bathrooms: '',
        num_closets: '',
        laundry_type: '',
        property_type: '',
        trash_type: '',
        apt_no: '',
        is_rent_total: 0,
        number_of_roommates: 0,
        furniture: 0,
        sign_on_fees: 0,
        parking: 0,
        parking_fees: 0
      });
      setSelectedBills([]);
      setBillEntryMode('individual');
    } catch (error) {
      console.error(error);
      setModalMessage('Failed to submit data. Please try again.');
    } finally {
      setIsSubmitting(false);
    }
  };

  // --- STYLED COMPONENTS ---
  const StarRating = ({ value, onChange, field }) => (
    <div className="star-rating">
      {[...Array(5)].map((_, index) => {
        const ratingValue = index + 1;
        return (
          <span
            key={ratingValue}
            className={ratingValue <= value ? 'star-filled' : 'star-empty'}
            onClick={() => onChange(field, ratingValue)}
          >
            &#9733;
          </span>
        );
      })}
    </div>
  );

  return (
    <>
      {/* --- CSS STYLES --- */}
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&display=swap');

        .form-container {
          font-family: 'Inter', sans-serif;
          background-color: #f9fafb;
          padding: 2rem 0;
        }

        .form-card {
          max-width: 800px;
          margin: auto;
          background: white;
          padding: 2.5rem;
          border-radius: 12px;
          box-shadow: 0 10px 25px -5px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);
        }

        .form-header {
          font-size: 1.75rem;
          font-weight: 700;
          color: #111827;
          margin-bottom: 2rem;
          text-align: center;
        }
        
        .ratings-section {
          display: flex;
          justify-content: center;
          gap: 4rem;
          margin-bottom: 2.5rem;
          text-align: center;
        }

        .rating-group p {
          font-size: 0.95rem;
          font-weight: 500;
          color: #4b5563;
          margin-bottom: 0.5rem;
        }
        
        .star-rating {
          display: inline-flex;
          gap: 0.25rem;
          font-size: 1.75rem;
        }

        .star-rating span {
          cursor: pointer;
          transition: color 0.2s, transform 0.2s;
        }
        
        .star-rating span:hover {
            transform: scale(1.15);
        }

        .star-filled {
          color: #f59e0b;
        }

        .star-empty {
          color: #d1d5db;
        }

        .form-grid {
          display: grid;
          grid-template-columns: repeat(2, 1fr);
          gap: 1.5rem;
        }

        .grid-col-span-2 {
          grid-column: span 2;
        }

        .form-group {
          display: flex;
          flex-direction: column;
        }

        .form-label {
          font-size: 0.875rem;
          font-weight: 500;
          color: #374151;
          margin-bottom: 0.5rem;
        }

        .form-input, .form-select, .form-textarea {
          width: 100%;
          padding: 0.75rem 1rem;
          font-size: 1rem;
          border: 1px solid #d1d5db;
          border-radius: 8px;
          background-color: white;
          transition: border-color 0.2s, box-shadow 0.2s;
        }
        
        .form-input:focus, .form-select:focus, .form-textarea:focus {
          outline: none;
          border-color: #3b82f6;
          box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.3);
        }
        
        .form-textarea {
            resize: vertical;
            min-height: 120px;
        }

        .bill-options {
          margin-top: 1rem;
          padding: 1rem;
          background-color: #f9fafb;
          border-radius: 8px;
        }
        
        .bill-options p {
            font-size: 0.9rem;
            font-weight: 500;
            margin: 0 0 0.75rem 0;
            color: #4b5563;
        }

        .checkbox-group {
          display: flex;
          flex-wrap: wrap;
          gap: 1.5rem;
        }

        .checkbox-label {
          display: flex;
          align-items: center;
          gap: 0.5rem;
          font-size: 0.95rem;
          cursor: pointer;
        }

        .checkbox-input {
          height: 1.25em;
          width: 1.25em;
          cursor: pointer;
        }
        
        .submit-container {
          margin-top: 2.5rem;
          text-align: center;
        }

        .submit-btn {
          background-color: #dd6b20;
          color: white;
          font-size: 1.1rem;
          font-weight: 600;
          padding: 0.8rem 2.5rem;
          border: none;
          border-radius: 8px;
          cursor: pointer;
          transition: background-color 0.3s, transform 0.2s;
          display: inline-flex;
          align-items: center;
          gap: 0.5rem;
        }
        
        .submit-btn:hover {
          background-color: #9b5322ff;
          transform: translateY(-2px);
        }
        
        .submit-btn:disabled {
          background-color: #9ca3af;
          cursor: not-allowed;
        }

        .loader {
          border: 3px solid rgba(255, 255, 255, 0.3);
          border-radius: 50%;
          border-top-color: #fff;
          width: 18px;
          height: 18px;
          animation: spin 1s ease-in-out infinite;
        }

        @keyframes spin {
          to { transform: rotate(360deg); }
        }

        @media (max-width: 768px) {
          .form-grid {
            grid-template-columns: 1fr;
          }
          .grid-col-span-2 {
            grid-column: span 1;
          }
          .form-card {
            padding: 1.5rem;
          }
          .ratings-section {
            flex-direction: column;
            gap: 1.5rem;
          }
        }
      `}</style>

      {/* --- JSX STRUCTURE --- */}
      <div className="form-container">
        <div className="form-card">
          <h2 className="form-header">Submit a New Review</h2>

          <div className="ratings-section">
            <div className="rating-group">
              <p>Overall Rating</p>
              <StarRating value={formData.stars} onChange={handleInputChange} field="stars" />
            </div>
            <div className="rating-group">
              <p>Maintenance Rating</p>
              <StarRating value={formData.maintenance_rating} onChange={handleInputChange} field="maintenance_rating" />
            </div>
          </div>
          
          <form onSubmit={handleSubmit}>
            <div className="form-grid">
              <div className="form-group grid-col-span-2">
                <label className="form-label" htmlFor="address">Street Address</label>
                <input id="street" className="form-input" value={formData.street} onChange={(e) => handleInputChange('street', e.target.value)} required />
              </div>

              <div className="form-group">
                <label className="form-label" htmlFor="state">City</label>
                <input id="city" type="form-input" className="form-input" value={formData.city} onChange={(e) => handleInputChange('city', e.target.value)} required />
              </div>

              <div className="form-group">
                <label className="form-label" htmlFor="state">State</label>
                <select id="state" className="form-select" value={formData.state} onChange={(e) => handleInputChange('state', e.target.value)} required>
                  <option value="">Select...</option>
                  {stateOptions.map((state) => (
                    <option key={state} value={state}>{state}</option>
                  ))}
                </select>
              </div>

              <div className="form-group">
                <label className="form-label" htmlFor="zip">Zip</label>
                <input id="zip" type="form-input" className="form-input" value={formData.zip} onChange={(e) => handleInputChange('zip', e.target.value)} required />
              </div>

               <div className="form-group">
                <label className="form-label" htmlFor="apt_no">Apartment Number (Optional)</label>
                <input id="apt_no" type="number" className="form-input" value={formData.apt_no} onChange={(e) => handleInputChange('apt_no', e.target.value)} />
              </div>

              <div className="form-group">
                <label className="form-label" htmlFor="rent">Monthly Rent ($)</label>
                <input id="rent" type="number" className="form-input" value={formData.rent} onChange={(e) => handleInputChange('rent', e.target.value)} required />
              </div>

              {[
                ['This rent is...', 'is_rent_total', rentTypeOptions]
              ].map(([label, field, options]) => (
                <div className="form-group" key={field}>
                  <label className="form-label" htmlFor={field}>{label}</label>
                  <select id={field} className="form-select" value={formData[field]} onChange={(e) => handleInputChange(field, e.target.value)}>
                    <option value="">Select...</option>
                    {options.map((opt) => (
                      <option key={opt.id} value={opt.id}>{opt.label}</option>
                    ))}
                  </select>
                </div>
              ))}

              <div className="form-group">
                <label className="form-label" htmlFor="numRoommates">Number of Roommates</label>
                <input id="numRoommates" type="number" className="form-input" value={formData.number_of_roommates} onChange={(e) => handleInputChange('number_of_roommates', e.target.value)} required />
              </div>

              {[
                ['Furniture', 'furniture', furnitureOptions]
              ].map(([label, field, options]) => (
                <div className="form-group" key={field}>
                  <label className="form-label" htmlFor={field}>{label}</label>
                  <select id={field} className="form-select" value={formData[field]} onChange={(e) => handleInputChange(field, e.target.value)}>
                    <option value="">Select...</option>
                    {options.map((opt) => (
                      <option key={opt.id} value={opt.id}>{opt.label}</option>
                    ))}
                  </select>
                </div>
              ))}

              <div className="form-group">
                <label className="form-label" htmlFor="rent">Sign On Fees ($)</label>
                <input id="rent" type="number" className="form-input" value={formData.sign_on_fees} onChange={(e) => handleInputChange('sign_on_fees', e.target.value)} required />
              </div>

              {[
                ['Parking', 'parking', parkingOptions]
              ].map(([label, field, options]) => (
                <div className="form-group" key={field}>
                  <label className="form-label" htmlFor={field}>{label}</label>
                  <select id={field} className="form-select" value={formData[field]} onChange={(e) => handleInputChange(field, e.target.value)}>
                    <option value="">Select...</option>
                    {options.map((opt) => (
                      <option key={opt.id} value={opt.id}>{opt.label}</option>
                    ))}
                  </select>
                </div>
              ))}

              {(() => {
                const selectedParkingOption = parkingOptions.find(
                  (opt) => opt.id.toString() === formData.parking?.toString()
                );

                if (selectedParkingOption?.label === 'Paid') {
                  return (
                    <ParkingFeeInput
                      value={formData.parking_fees}
                      onChange={handleInputChange}
                    />
                  );
                }

                return null;
              })()}

              <div className="form-group grid-col-span-2">
                 <label className="form-label" htmlFor="review_text">Your Review</label>
                 <textarea id="review_text" className="form-textarea" value={formData.review_text} onChange={(e) => handleInputChange('review_text', e.target.value)} />
              </div>
              
              <div className="form-group grid-col-span-2">
                <label className="form-label" htmlFor="bill-mode-label">Utility Bill Entry Type</label>
                <select id="bill-mode-label" className="form-select" value={billEntryMode} onChange={(e) => {
                  setBillEntryMode(e.target.value);
                  if (e.target.value === 'unified') {
                    setSelectedBills([]);
                    handleInputChange('electricity_bill', '');
                    handleInputChange('water_bill', '');
                    handleInputChange('gas_bill', '');
                  } else {
                    handleInputChange('unified_bill', '');
                  }
                }}>
                  <option value="individual">Enter Individual Bills</option>
                  <option value="unified">Enter One Unified Bill</option>
                </select>

                {billEntryMode === 'individual' && (
                  <div className="bill-options">
                    <p>Which bills would you like to report?</p>
                    <div className="checkbox-group">
                      {['electricity_bill', 'water_bill', 'gas_bill'].map((bill) => (
                        <label key={bill} className="checkbox-label">
                          <input type="checkbox" className="checkbox-input" checked={selectedBills.includes(bill)} onChange={(e) => {
                            const updated = e.target.checked ? [...selectedBills, bill] : selectedBills.filter((b) => b !== bill);
                            setSelectedBills(updated);
                            if (!e.target.checked) handleInputChange(bill, '');
                          }} />
                          {bill.replace('_bill', '').replace('_', ' ').replace(/\b\w/g, c => c.toUpperCase())}
                        </label>
                      ))}
                    </div>
                  </div>
                )}
              </div>

              {billEntryMode === 'unified' ? (
                <div className="form-group">
                  <label className="form-label" htmlFor="unified_bill">Unified Utility Bill ($)</label>
                  <input id="unified_bill" type="number" className="form-input" value={formData.unified_bill} onChange={(e) => handleInputChange('unified_bill', e.target.value)} />
                </div>
              ) : (
                selectedBills.map((billKey) => (
                  <div className="form-group" key={billKey}>
                    <label className="form-label" htmlFor={billKey}>{`${billKey.replace('_bill', '').replace('_', ' ').replace(/\b\w/g, c => c.toUpperCase())} Bill ($)`}</label>
                    <input id={billKey} type="number" className="form-input" value={formData[billKey] || ''} onChange={(e) => handleInputChange(billKey, e.target.value)} />
                  </div>
                ))
              )}

              <div className="grid-col-span-2" style={{height: 0, borderTop: '1px solid #e5e7eb', margin: '0.5rem 0'}}></div>

              {[
                ['Bedrooms', 'num_bedrooms'],
                ['Bathrooms', 'num_bathrooms'],
                ['Closets', 'num_closets'],
              ].map(([label, field]) => (
                <div className="form-group" key={field}>
                  <label className="form-label" htmlFor={field}>{label}</label>
                  <input id={field} type="number" className="form-input" value={formData[field]} onChange={(e) => handleInputChange(field, e.target.value)} />
                </div>
              ))}
              
              {[
                ['Property Type', 'property_type', propertyTypeOptions],
                ['Laundry Type', 'laundry_type', laundryOptions],
                ['Trash Type', 'trash_type', trashTypeOptions],
              ].map(([label, field, options]) => (
                <div className="form-group" key={field}>
                  <label className="form-label" htmlFor={field}>{label}</label>
                  <select id={field} className="form-select" value={formData[field]} onChange={(e) => handleInputChange(field, e.target.value)}>
                    <option value="">Select...</option>
                    {options.map((opt) => (
                      <option key={opt.id} value={opt.id}>{opt.label}</option>
                    ))}
                  </select>
                </div>
              ))}

            </div>

            <div className="submit-container">
              <button type="submit" className="submit-btn" disabled={isSubmitting}>
                {isSubmitting && <div className="loader"></div>}
                {isSubmitting ? 'Submitting...' : 'Submit Review'}
              </button>
            </div>
          </form>
        </div>
      </div>
    </>
  );
};

export default SubmitDataForm;